<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="bg-gray px-4 py-1 h-100">
          <div class="card bg-white rounded-5 mt-2 shadow border-0 h-100">
            <div class="card-header bg-transparent border-0">
              <button class="btn btn-sm bg-transparent fw-bold" @click="$router.back()">
          <i class="bi bi-arrow-left me-1 fs-5"></i>
        </button>
              <span class="fw-500">Membership History</span>
            </div>

            <div class="card-body">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

              <div class="row g-2 mb-3">
                <div
                  v-for="card in membership_history_dashboard_cards"
                  :key="card.label"
                  class="col-6 col-md-4 col-xl"
                >
                  <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                    <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                      <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                        <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                        <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                      </div>
                      <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                        <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <Loader v-if="isLoading" :loading="isLoading" label="Loading membership history..." />
              <!-- Show table only if there is data -->
              <div v-else-if="membership_payment_history && membership_payment_history.length" class="table-responsive">
                <table class="table table-striped text-xxs mt-2 align-middle mb-0">
                  <thead class="btn-primary text-white">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Membership Name</th>
                      <th scope="col">Membership Type</th>
                      <th scope="col">Membership Amount</th>
                      <th scope="col">User Full Name</th>
                      <th scope="col">Membership Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(membership_history, index) in membership_payment_history" :key="membership_history.id">
                        <th scope="row">{{ index + 1 }}</th>
                        <td>{{membership_name}}</td>
                        <td>{{membership_type }}</td>
                        <td>{{ membership_price }}</td>
                        <td>{{ user_first_name }} {{ user_last_name }}</td>
                        <td>{{ payment_status }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else class="text-center py-5 border rounded-3">
                <i class="bi bi-inbox fs-1 text-muted d-block mb-2" aria-hidden="true"></i>
                <div class="mb-1">No membership history yet</div>
                <div class="small text-muted">When payments are made, they’ll show up here.</div>
              </div>
            </div> <!-- /card-body -->
          </div> <!-- /card -->
        </div>
      </div>
    </div>
  </div>
</div>
